import React from 'react'
import moment from 'moment'
import { FaIcon, faCalendar } from '@/lib/fa'
import { DateField } from '@/ui/form/controls/DateField'
import { TimeField } from '@/ui/form/controls/TimeField'
import { useAlertForm } from '../AlertFormContext'

const AlertDate = () => {
  const { eventDate, setEventDate, eventTime, setEventTime } = useAlertForm()

  const handleDateChange = (fullDate: string | null) => {
    if (!fullDate) return
    const [year, month, day] = fullDate.split('-').map(Number)
    const next = moment(eventDate)
      .year(year)
      .month(month - 1)
      .date(day)
    setEventDate(next)
  }

  const handleTimeChange = (time: string | null) => {
    const next = time ?? ''
    setEventTime(next)
    if (!next) return
    const [hours, minutes] = next.split(':').map(Number)
    setEventDate(eventDate.clone().set({ hour: hours, minute: minutes }))
  }

  return (
    <div className="tw-flex tw-gap-2">
      <div className="tw-jusit tw-flex tw-max-w-[200px] tw-flex-1 tw-items-start tw-gap-2 tw-font-medium tw-text-content-base">
        <FaIcon icon={faCalendar} className="tw-max-w-[12px]" />
        <p className="tw-text-sm tw-font-semibold tw-text-content-base">
          Data zdarzenia
        </p>
      </div>

      <div className="tw-flex tw-flex-1 tw-gap-3">
        <DateField
          label="Data"
          value={eventDate.format('YYYY-MM-DD')}
          setValue={handleDateChange}
        />
        <TimeField
          label="Godzina"
          value={eventTime}
          setValue={handleTimeChange}
        />
      </div>
    </div>
  )
}

export default AlertDate
